<template>
    <v-dialog v-model="shows">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card>
            <v-card-title>첨부파일</v-card-title>
            <v-card-text class="px-1">
                <vertical-form-table
                    v-model="form"
                    v-bind="{
                        items,
                        class: 'view-file',
                    }"
                    @input="emit"
                >
                    <template v-for="item in items" :slot="item.term">
                        <v-row align="center" no-gutters :key="item.term">
                            <v-col>
                                <v-file-input :value="form[item?.key?.split?.('.')?.shift?.()]?.file" outlined hide-details="auto" disabled :clearable="false" />
                            </v-col>
                            <v-col cols="auto" class="ml-10px">
                                <v-btn :href="form[item?.key?.split?.('.')?.shift?.()]?.file?.url" download color="primary" outlined x-large>다운로드</v-btn>
                            </v-col>
                        </v-row>
                    </template>
                </vertical-form-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { attrs_input, EMPLOYMENT_FIELD_TYPES, initEmploymentContract } from "@/assets/variables";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

export default {
    components: {
        VerticalFormTable,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
        loading: { type: Boolean, default: false },
    },
    setup: () => ({
        attrs_input,
    }),
    data: () => ({
        /** @type {Object<string, import('@/assets/variables').EmploymentField>} */
        form: {},

        shows: false,
    }),
    computed: {
        items() {
            return Object.keys(this.form).map((key) => ({
                key: `${key}.file`,
                term: this.form[key]?.term,
                type: "file",
                required: this.form[key]?.isRequired,

                outlined: true,
                wrap: true,
            }));
        },
        disabled() {
            return Object.values(this.form).some((item) => item.isRequired && !item.file);
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        value() {
            this.sync();
        },
        disabled() {
            this.emitDisabled();
        },
    },
    methods: {
        init() {
            this.emitDisabled();
            this.sync();
        },

        sync() {
            /** @type {import('@/assets/variables').EmploymentContract} */
            let { fields_employee } = this.value;

            this.form = fields_employee.reduce((form, item) => {
                if (item.type == EMPLOYMENT_FIELD_TYPES.FILE.value) {
                    form[item.tempId] = item;
                }

                return form;
            }, {});
        },

        emit() {
            /** @type {import('@/assets/variables').EmploymentContract} */
            let { fields_employee } = this.value;

            fields_employee = fields_employee.map((item) => this.form[item.tempId] || item);

            this.$emit("input", { ...this.value, fields_employee });
        },

        emitDisabled() {
            this.$emit("setDisabled", this.disabled);
        },
    },
};
</script>

<style lang="scss" scoped>
.view-file {
    font-weight: 500;

    ::v-deep(.v-divider) {
        display: none;
    }
    ::v-deep(.row.ma-0) {
        > .col-auto {
            width: 100% !important;
            margin: auto 0;
        }
    }
    ::v-deep(.v-input) {
        .v-input__prepend-outer {
            margin-top: 12px;
        }
    }

    @media (min-width: 768px) {
        ::v-deep(.row.ma-0) {
            > .col-auto {
                width: 120px !important;
            }
        }
    }

    @media (min-width: 1024px) {
        font-size: 16px;
        ::v-deep(.row.ma-0) {
            > .col {
                padding: 16px 20px !important;
            }
            > .col-auto {
                width: 194px !important;
            }
        }
    }
}
</style>
